export default {
    Id: 0,
    PaymentDirection: 1,
    PaymentOperationID: 0,
    CategoryId: 0,
    PaymentTypeId: 0,
    CashId: 0,
    PaymentAccountId: 0,
    AccountNumber: '',

    Sum: 0,
    BankCommission: 0,

    PaymentDate: '',
    DocumentNumber: '',
    Comment: '',

    PaymentDetails:[],
    loading: false,
}